export const SECRET_SLUG = 'secret-group-slug-used-for-editor';
export const FEED_WIDGET_SECRET_SLUG =
  'secret-publicgroup-slug-used-for-editor';
